import React from "react";
import dayjs from "dayjs";
import { getRestaurant } from "../../../utils/commons";

const Aboutus = () => {
	const restaurant = getRestaurant();
	const timetables = restaurant.TimetablesDefinitions.reduce((acc, time) => {
		if (!acc[time.day]) {
			acc[time.day] = [];
		}
		acc[time.day].push(time);
		return acc;
	}, {});

	return (
		<div className="section" style={{ padding: 0 }}>
			<div className="container">
				<div className="row about-info-container">
					<div className="col-xl-5 mb-lg-30 ct-single-img-wrapper">
						<div id="map"></div>
						{/* <div className="ct-dots" /> */}
					</div>
					<div className="col-xl-7">
						<div className="section-title-wrap mr-lg-30">
							<h5 className="custom-primary">Adresse :</h5>
							<div className="col-12 justify-content-around">
								<div className="row">
									<div className="col-12">
										<p>
											<i className="fas fa-map-marker-alt mr-2" />
											{restaurant.address + ", "} <br />
											{restaurant.zipCode + " " + restaurant.city}
										</p>
									</div>
								</div>
							</div>
							<h5 className="custom-primary">Téléphone :</h5>
							<div className="col-sm-12 col-12 justify-content-around">
								<div className="row">
									<div className="col-12">
										<a href={"tel:" + restaurant.landline}>
											<p>
												<i className="fas fa-phone mr-2" />
												{restaurant.landline}
											</p>
										</a>
									</div>
								</div>
							</div>
							<h5 className="custom-primary">Horaires :</h5>
							<div className="col-12 justify-content-around">
								{timetables &&
									Object.keys(timetables).map((day) => {
										return (
											<div className="row" key={day}>
												<span className="col-4">{day} :</span>
												{timetables[day] &&
													timetables[day].map((period, index) => {
														return (
															<span
																className="col-4"
																key={index + period.startTime}
															>
																{dayjs(period["startTime"]).format("HH:mm") +
																	" - " +
																	dayjs(period["endTime"]).format("HH:mm")}
															</span>
														);
													})}
											</div>
										);
									})}
							</div>

							<div className="col-sm-12 col-12 justify-content-around">
								<img
									className="logo"
									src="assets/img/MangoPay_Logo_black.png"
									alt="img"
									width="120"
									height="50"
								/>

								<span> Paiement sécurisé</span>
							</div>
							{/* 
								<Link to='/' className='btn-custom'>
									Check our Menu
								</Link> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Aboutus;
